import React from "react";
import { Formik, Form, Field } from "formik";
import { Button, LinearProgress } from "@material-ui/core";
import { TextField } from "formik-material-ui";
import { makeStyles } from "@material-ui/core";
import yellow from "@material-ui/core/colors/yellow";
import erc721abi from "../../ethereum/abi/erc721";
import { ethers } from "ethers";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  formField: {
    marginBottom: "5px",
    fontFamily: "Work Sans, sans-serif",
  },
  buttonstyle: {
    fontFamily: "Work Sans, sans-serif",
    fontWeight: "bold",
    fontSize: "16px",
    color: yellow[800],
    background: "#fff",
    "&:hover": {
      backgroundColor: yellow[400],
      color: "#000",
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent",
      },
    },
  },
}));

const NftMintInput = ({ onSelect }) => {
  const { formField, buttonstyle } = useStyles();
  const wallet = useSelector((state) => state.wallet);

  const handleChange = (hash) => {
    onSelect(hash);
  };

  const interactContract = async (values) => {
    const gasPrice = await wallet.provider.getGasPrice();
    let gas_price = ethers.utils.hexlify(parseInt(gasPrice));
    let gas_limit = "0x100000"
    
    const nftContractInstance = new ethers.Contract(
      values.NftContractAddress,
      erc721abi,
      wallet.signer
    );
    const WithSigner = nftContractInstance.connect(wallet.signer);
    const tx = await WithSigner.safeMint(values.NftReciever, values.TokenID,{
      
      nonce: wallet.provider.getTransactionCount(
        wallet.account,
        "latest"
      ),
      gasLimit: ethers.utils.hexlify(gas_limit),
      gasPrice: gas_price
    });

    console.log("tx", tx);
    let lastConfirms = -1;
    async function handler(blockNumber) {
      let receipt = await wallet.provider.getTransactionReceipt(tx.hash);
      if (receipt == null || receipt.confirmation < lastConfirms) {
        // A re-org; do what you need here
        console.log("blockNumber-->", blockNumber);
      }
    }
    wallet.provider.on("block", handler);

    tx.wait(1).then((receipt) => {
      // This gets called once there are 3 confirmations
      console.log("tx confirmed");
      console.log("reciept", receipt);
      handleChange(receipt.transactionHash);
      wallet.provider.removeListener("block", handler);
    });
  };
  return (
    <>
      <Formik
        initialValues={{
          NftReciever: "",
          NftContractAddress: "",
          TokenID: "",
        }}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          interactContract(values);
          resetForm();
        }}
      >
        {({ submitForm, isSubmitting }) => (
          <Form>
            <Field
              className={formField}
              component={TextField}
              name="NftReciever"
              label="Nft Reciever"
              fullWidth
              variant="outlined"
            />
            <br />
            <br />
            <Field
              component={TextField}
              label="Nft Contract Address"
              name="NftContractAddress"
              fullWidth
              variant="outlined"
              className={formField}
            />
            <br />
            <br />
            <Field
              component={TextField}
              label="TokenID"
              name="TokenID"
              fullWidth
              variant="outlined"
              className={formField}
            />
            {isSubmitting && <LinearProgress />}
            <br />
            <br />
            <Button
              variant="contained"
              disabled={isSubmitting}
              onClick={submitForm}
              fullWidth
              className={buttonstyle}
            >
              Submit
            </Button>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default NftMintInput;
